import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 gy-2" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Summary ", -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-text" }
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "input-group mb-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "name"
}, "Name", -1)
const _hoisted_14 = { class: "input-group mb-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "receiverCode"
}, "Receiver Code", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("option", { value: "00" }, "00", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("option", { value: "01" }, "01", -1)
const _hoisted_18 = { class: "input-group" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "receiverCode"
}, "SIMS Class code", -1)
const _hoisted_20 = {
  class: "btn-toolbar justify-content-end m-2 mt-0",
  role: "toolbar",
  "aria-label": "Company Actions"
}
const _hoisted_21 = {
  class: "btn-group",
  role: "group",
  "aria-label": "List actions"
}
const _hoisted_22 = { class: "col-md-6 gy-2" }
const _hoisted_23 = { class: "card" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Departments", -1)
const _hoisted_25 = { class: "card-body p-0" }
const _hoisted_26 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_27 = { class: "table table-striped mb-0" }
const _hoisted_28 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Name"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Last Update"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Chain length")
  ])
], -1)
const _hoisted_29 = { scope: "row" }
const _hoisted_30 = {
  key: 0,
  class: "btn-toolbar justify-content-end m-2",
  role: "toolbar",
  "aria-label": "Company Export Actions"
}
const _hoisted_31 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Export actions"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col gy-2" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Department Escalation Data ", -1)
const _hoisted_35 = { class: "card-header" }
const _hoisted_36 = { class: "list-group list-group-flush" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-4" }
const _hoisted_39 = { class: "col-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    (_ctx.company)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, [
                  _createVNode("p", _hoisted_8, [
                    _createTextVNode(" Company Uid: " + _toDisplayString(_ctx.company.CompanyUId), 1),
                    _hoisted_9,
                    _createTextVNode(" Last Update: " + _toDisplayString(_ctx.company.LastUpdate ? _ctx.getHumanDate(_ctx.company.LastUpdate) : 'n/a'), 1),
                    _hoisted_10,
                    _createTextVNode(" Last Export: " + _toDisplayString(_ctx.company.LastExport ? _ctx.getHumanDate(_ctx.company.LastExport) : 'n/a'), 1),
                    _hoisted_11
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "Name",
                      "aria-label": "Name",
                      "aria-describedby": "simsClass",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.company.Name = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.company.Name,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createVNode("select", {
                      class: "form-select",
                      "aria-label": "Receiver Code",
                      "aria-describedby": "receiverCode",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.company.ReceiverCode = $event))
                    }, [
                      _hoisted_16,
                      _hoisted_17
                    ], 512), [
                      [_vModelSelect, _ctx.company.ReceiverCode]
                    ])
                  ]),
                  _createVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "Code",
                      "aria-label": "Code",
                      "aria-describedby": "simsClass",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.company.SimsClass = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.company.SimsClass,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode("button", {
                      class: "ms-auto btn btn-outline-primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateCompanyData()))
                    }, "Update")
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("div", _hoisted_25, [
                  (_ctx.departments.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_26, [
                        _createVNode("table", _hoisted_27, [
                          _hoisted_28,
                          _createVNode("tbody", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.departments, (department) => {
                              return (_openBlock(), _createBlock("tr", {
                                key: department.id
                              }, [
                                _createVNode("td", _hoisted_29, _toDisplayString(department.Name), 1),
                                _createVNode("td", null, _toDisplayString(_ctx.getHumanDate(department.LastUpdate)), 1),
                                _createVNode("td", null, _toDisplayString(department.Escalations.length), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.exportable)
                  ? (_openBlock(), _createBlock("div", _hoisted_30, [
                      _createVNode("div", _hoisted_31, [
                        (_ctx.company.LastExport)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              class: "ms-auto btn btn-outline-primary",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.triggerExport('partial')))
                            }, "Partial Export"))
                          : _createCommentVNode("", true),
                        _createVNode("button", {
                          class: "ms-auto btn btn-outline-primary",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.triggerExport('full')))
                        }, "Export All")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, [
              _hoisted_34,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.departments, (department) => {
                return (_openBlock(), _createBlock("div", {
                  class: "card col col-md-6 mt-2",
                  key: department.id
                }, [
                  _createVNode("div", _hoisted_35, _toDisplayString(department.Name) + " (" + _toDisplayString(department.id) + ")", 1),
                  _createVNode("ul", _hoisted_36, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(department.Escalations, (escalation, index) => {
                      return (_openBlock(), _createBlock("li", {
                        class: "list-group-item",
                        key: index
                      }, [
                        _createVNode("div", _hoisted_37, [
                          _createVNode("div", _hoisted_38, _toDisplayString(escalation.Type), 1),
                          _createVNode("div", _hoisted_39, _toDisplayString(escalation.Name) + " " + _toDisplayString(escalation.Phone) + " " + _toDisplayString(escalation.Email), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}